/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const postApiEmployeesIdCvRevertRequestPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const postApiEmployeesIdCvRevertRequest200Schema = z.any();

export const postApiEmployeesIdCvRevertRequestMutationResponseSchema = z.lazy(
  () => postApiEmployeesIdCvRevertRequest200Schema,
);
